import React from 'react'
import { Modal, Frame } from '@react95/core'
import { Heading, Text } from '@pancakeswap/uikit'
import { Inetcpl1318 } from '@react95/icons'
import { useTranslation } from 'contexts/Localization'
import { useWeb3React } from '@web3-react/core'
import ConnectWalletButton from 'components/ConnectWalletButton'
import truncateHash from 'utils/truncateHash'
import { AutoRow } from 'components/Layout/Row'
// import { useCurrency } from 'hooks/Tokens'
import Column from 'components/Layout/Column'
import useMigrationAccount from 'hooks/useMigrationAccount'
import { FetchStatus } from 'hooks/useTokenBalance'

const ReflectionModal = ({ close, modalStyle, frameStyle }) => {
  const { t } = useTranslation()
  const { account } = useWeb3React()
  const truncatedAddress = truncateHash(account ?? '')
  // const windoge95 = useCurrency(tokens.windoge95.address)
  const migrationAccount = useMigrationAccount()

  const rewardsSinceLastTrade =
    migrationAccount?.fetchStatus === FetchStatus.NOT_FETCHED
      ? 'Loading...'
      : migrationAccount?.fetchStatus === FetchStatus.FAILED
      ? 'Error fetching balance'
      : `${(Number.parseInt((migrationAccount?.migrationAccount?.reflections || 0).toString()) / 1000000000)
          .toFixed(0)
          .toString()}`

  return (
    <Modal
      defaultPosition={{ x: 12, y: 12 }}
      icon={<Inetcpl1318 />}
      title="Reflections Tracker"
      closeModal={close}
      width="90vw"
      height="90vh"
      style={modalStyle}
      buttons={[{ value: 'Ok', onClick: close }]}
    >
      <Frame style={frameStyle}>
        <Heading scale="xl" mb="16px" mt="16px">
          {t(`Track your Windoge Reflections`)}
        </Heading>
        <Text fontSize="18px" mb="24px">
          {t(`Use this simple interface to check how many reflections you have earned since your last trade.`)}
        </Text>
        <Text fontSize="18px">{t(`Step 1: Connect your wallet`)}</Text>
        <Text fontWeight="bold" fontSize="24px" mb="24px">
          {account && t('Connected with %address%', { address: truncatedAddress })}
        </Text>
        {/* {account && (
          <>
            <Text fontSize="24px" fontWeight="bold">
              {t(`Your Windoge95 V2 Balance:`)}
            </Text>
            <Text fontSize="24px" fontWeight="bold">
              {windogeBalance?.toFixed(2)} WNDG
            </Text>
          </>
        )} */}
        {!account && <ConnectWalletButton />}
        <Text mt="24px" fontSize="18px">
          {t(`Your Reflections since your last trade:`)}
        </Text>

        <AutoRow gap="6px" justify="space-between">
          <Column>
            <Text fontSize="24px" fontWeight="bold">
              {rewardsSinceLastTrade} WNDG V2
            </Text>
          </Column>
        </AutoRow>
      </Frame>
    </Modal>
  )
}

export default ReflectionModal
